<i18n>
{
"en": {
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",
  "ROUTES": "Routes",
  "BUSNUMBER": "Bus Number",
  "NAME": "Name",
  "DRIVER": "Driver",
  "SUPERVISOR": "Supervisor",
  "MANAGEROUTE": "Manage Route",
  "DESCRIPTION": "Description",
  "SELECTDRIVER": "Select Driver",
  "SELECTSUPERVISOR": "Select Supervisor",
  "CANCEL": "Cancel",
  "SAVING": "Saving",
  "SAVE": "Save",
  "INFORMATION": "Information",
  "DIRECTION": "Direction",
  "SELECTDIRECTION": "Select Direction",
  "SELECTSERVICEDATE": "Select Service Date",
  "SELECTTERM": "Select Term",
  "SELECTTYPE": "Select Type",
  "ACADEMICYEAR": "Academic Year",
  "CUSTOMDATE": "Custom Date",
  "SELECTACADEMICTERM": "Select Academic Term",
  "SERVICESTARTENDDATE": "Service Start & End Date",
  "SERVICESTARTDATE": "Service Start Date",
  "SERVICEENDDATE": "Service End Date",
  "PICKADATE": "Pick a date",
  "DAYSINSERVICE": "Days in Service",
  "CHECKALL": "Check all",
  "HOMETOSCHOOLSERVICETIME": "Home to School Service Time",
  "STARTTIME": "Start time",
  "ENDTIME": "End time",
  "SCHOOLTOHOMESERVICETIME": "School to Home Service Time",
  "PLEASEINPUT": "Please input",
  "ROUTECOLOR": "Route Color",
  "STOPS": "Stops",
  "ADDSTUDENTTOASTOP": "Add student to a stop",
  "TOSCHOOL": "To School",
  "TOHOME": "To Home",
  "LINE-THROUGH": "line-through",
  "NONE": "none",
  "STOP": "Stop",
  "GPSLATITUDE": "GPS Latitude",
  "GPSLONGITUDE": "GPS Longitude",
  "USEGOOGLEMAPDURATION": "Use google map duration",
  "YES": "Yes",
  "NO": "No",
  "PREVIOUSWAITING": "Previous waiting",
  "STOPWAITING": "Stop waiting",
  "CONFIRM": "Confirm",
  "NOSTUDENTSADDEDTOTHISSTOP": "No students added to this stop",
  "REGISTRATION": "Registration",
  "STUDENTS": "Students",
  "SENDING": "Sending...",
  "SENDREGISTRATIONCODE": "Send Registration Code",
  "SETTINGS": "Settings",
  "STATUS": "Status",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "COPYROUTE": "Copy Route",
  "NAMEYOURROUTE": "Name your route",
  "CLONING": "Cloning...",
  "COPYING": "Copying...",
  "MAKEACOPY": "Make a Copy",
  "LOADING": "Loading...",
  "OVERVIEW": "Overview",
  "BUS": "Bus",
  "TRIPS": "Trips",
  "VIOLATIONS": "Violations",
  "INCIDENTS": "Incidents",
  "SELECTBUS": "Select Bus",
  "SELECTEDBUS": "Selected Bus",
  "AVAILABLEBUSES": "Available Buses",
  "BUSALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": "Bus already existed in the following route(s):",
  "PLEASECONFIRMIFYOUWOULDTOADDITTOTHISROUTE": "Please confirm if you would to add it to this route!",
  "SELECTEDDRIVER": "Selected Driver",
  "AVAILABLEDRIVERS": "Available Drivers",
  "DRIVERALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": "Driver already existed in the following route(s):",
  "PLEASECONFIRMIFYOUWOULDTOADDHIM/HERTOTHISROUTE": "Please confirm if you would to add him/her to this route!",
  "SELECTEDSUPERVISOR": "Selected Supervisor",
  "AVAILABLESUPERVISORS": "Available Supervisors",
  "SUPERVISORALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": "Supervisor already existed in the following route(s):",
  "ISREQUIRED": "is required.",
  "ERROR": "Error",
  "CLOSE": "Close",
  "SUNDAY": "Sunday",
  "MONDAY": "Monday",
  "TUESDAY": "Tuesday",
  "WEDNESDAY": "Wednesday",
  "THURSDAY": "Thursday",
  "FRIDAY": "Friday",
  "SATURDAY": "Saturday",
  "HOMETOSCHOOL": "Home to School",
  "SCHOOLTOHOME": "School to Home",
  "BOTH(ROUNDTRIP)": "Both (Round Trip)",
  "SWITCHTOPICK-UP": "Switch to Pick-up",
  "SWITCHTODROP-OFF": "Switch to Drop-off",
  "FARTHEST": "Farthest",
  "CLOSEST": "Closest",
  "PICK-UP": "Pick-up",
  "DROP-OFF": "Drop-off",
  "STUDENT": "Student",
  "CANNOTBEADDEDTOTHEROUTE": "cannot be added to the route. Please check if is disabled or has no primary guardian!",
  "ADD": "Add",
  "ALREADYEXISTEDINSTOP#": "already existed in stop#:",
  "ALREADYEXISTEDINROUTE": "already existed in route:",
  "WOULDYOULIKETOADDTHISSTUDENTTOTHISROUTE": "Would you like to add this student to this route?",
  "SUCCESSFULLYBEENASSIGNEDTOSTOP": "successfully been assigned to stop #",
  "SUCCESS" : "Route successfully saved!",
  "DEACTIVATED": "Deactivated",
  "RESTORED": "Restored",
  "ROUTESUCCESSFULLYCLONED": "Route successfully cloned",
  "NATIONALITY": "Nationality",
  "STATUS": "Status",
  "LICENSEEXPIRATION": "License Expiration",
  "ASSIGN": "Assign",
  "ASSIGNING": "Assigning...",
  "PLEASECONFIRM":"Please confirm",
  "NOTASSIGNED":"Not assigned",
  "MAKE": "Make",
  "MODEL": "Model",
  "YEAR": "Year",
  "SEATS": "Seats",
  "STOPMESSAGE1": "Student {name} cannot be added to the route. Please check if is disabled or has no primary guardian!",
  "STOPMESSAGE2": "{name} already existed in route:  {route}. Cannot be added during scheduled time!",
  "STOPMESSAGE3": "Student {name} already existed in stop#:  {stop}.",
  "STOPMESSAGE4": "Student {name} successfully been assigned to stop#:  {stop}.",
  "STOPMESSAGE5": "Seems that {name} has located at school location, Please reassign the actual location of student first!",
  "ROUTESUCCESSFULLY": "Route successfully",
  "UPLOADCSVFILE": "Upload CSV File",
  "GENERATEROUTE" : "Generate Route",
  "STUDENTID": "Student ID",
  "INPROGRESS" :"In Progress",
  "ROUTEISOTIMIZED" :"Route is Optimized",
  "DELAYEDTHRESHOLD": "Delayed Threshold",
  "FILLINFORMATION": "Please fill the Information tab first"
},
"ar": {
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا", 
  "ROUTES": "خط السير",
  "BUSNUMBER": "رقم الحافلة",
  "NAME": "الاسم",
  "DRIVER": "السائق",
  "SUPERVISOR": "المشرفة",
  "MANAGEROUTE": "ادارة خطوط السير",
  "DESCRIPTION": "الوصف",
  "SELECTDRIVER": "اختر السائق",
  "SELECTSUPERVISOR": "اختر المشرفة",
  "CANCEL": "الغاء",
  "SAVING": "احتفاظ",
  "SAVE": " حفظ",
  "INFORMATION": "معلومات",
  "DIRECTION": "اتجاه",
  "SELECTDIRECTION": "تحديد الاتجاه",
  "SELECTSERVICEDATE":"حدد تاريخ الخدمة",
  "SELECTTERM":"حدد الفترة الدراسية",
  "SELECTTYPE": "اختر صنف",
  "ACADEMICYEAR":"السنة الدراسية",
  "CUSTOMDATE": "تعديل التاريخ",
  "SELECTACADEMICTERM":"حدد الفترة الدراسية",
  "SERVICESTARTENDDATE": "تاريخ بدء الخدمة وانتهائها",
  "SERVICESTARTDATE": "تاريخ بدء الخدمة",
  "SERVICEENDDATE": "تاريخ انتهاء الخدمة",
  "PICKADATE": "اختر تاريخا",
  "DAYSINSERVICE": "أيام الخدمة",
  "CHECKALL": "تحقق من الكل",
  "HOMETOSCHOOLSERVICETIME": "وقت الخدمة من البيت الى المدرسة",
  "STARTTIME": "بداية الخدمة",
  "ENDTIME": "نهاية الخدمة",
  "SCHOOLTOHOMESERVICETIME": "وقت الخدمة من المدرسة الى البيت",
  "PLEASEINPUT": "الرجاء إدخال",
  "ROUTECOLOR": "لون خط السير",
  "STOPS": "توقفات",
  "ADDSTUDENTTOASTOP": "إضافة الطالب للتوقف",
  "TOSCHOOL": "الى المدرسة",
  "TOHOME": "إلى البيت",
  "LINE-THROUGH": "عبر الخط",
  "NONE": "لا شيء",
  "STOP": "توقف",
  "GPSLATITUDE": "GPSخط العرض بنظام ",
  "GPSLONGITUDE": "GPS خط الطول بنظام ",
  "USEGOOGLEMAPDURATION": " GOOGLE استخدام مدة خريطة",
  "YES": "نعم",
  "NO": "لا",
  "PREVIOUSWAITING": "الانتظار السابق",
  "STOPWAITING": "الانتظار في التوقف ",
  "CONFIRM": "تؤكد",
  "NOSTUDENTSADDEDTOTHISSTOP": "لم يضاف أي طالب إلى هذا التوقف",
  "REGISTRATION": "التسجيل",
  "STUDENTS": "الطلاب",
  "SENDING": "...إرسال",
  "SENDREGISTRATIONCODE": "ارسل رمز التسجيل",
  "SETTINGS": "إعدادات",
  "STATUS": "الحالة",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "COPYROUTE": "نسخ خط السير",
  "NAMEYOURROUTE": "حدد اسم خط السير",
  "CLONING": "...استنساخ",
  "COPYING": "...نسخ ", 
  "MAKEACOPY": "اعمل نسخة",
  "LOADING": "...جار التحميل",
  "OVERVIEW": "نظرة عامة",
  "BUS": "حافلة",
  "TRIPS": "رحلات",
  "VIOLATIONS": "انتهاكات",
  "INCIDENTS": "حوادث",
  "SELECTBUS": "حدد الحافلة",
  "SELECTEDBUS": " حافلة محددة",
  "AVAILABLEBUSES": " الحافلات المتوفرة",
  "BUSALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": ":الحافلة موجودة بالفعل في المسار (الطرق) التالية",
  "PLEASECONFIRMIFYOUWOULDTOADDITTOTHISROUTE": "يرجى تأكيد ما إذا كنت تريد إضافته إلى هذا الطريق!",
  "SELECTEDDRIVER": "حدد السائق",
  "AVAILABLEDRIVERS": "السائقين المتوفرين",
  "DRIVERALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": ":السائق موجود بالفعل في المسار (الطرق) التالي",
  "PLEASECONFIRMIFYOUWOULDTOADDHIM/HERTOTHISROUTE": "يرجى تأكيد ما إذا كنت ترغب في إضافته / ها إلى هذا الطريق!",
  "SELECTEDSUPERVISOR": "المشرفة المحددة",
  "AVAILABLESUPERVISORS": "المشرفات المتوفرات",
  "SUPERVISORALREADYEXISTEDINTHEFOLLOWINGROUTE(S)": ":المشرفة موجودة بالفعل في المسار (الطرق) التالي",
  "ISREQUIRED": ".مطلوب",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "SUNDAY": "الأحد",
  "MONDAY": "الإثنين",
  "TUESDAY": "الثلاثاء",
  "WEDNESDAY": "الأربعاء",
  "THURSDAY": "الخميس",
  "FRIDAY": "الجمعة",
  "SATURDAY": " السبت",
  "HOMETOSCHOOL": "من البيت إلى المدرسة",
  "SCHOOLTOHOME": "من المدرسة إلى البيت",
  "BOTH(ROUNDTRIP)":"كلا (رحلة ذهابا وإيابا)",
  "SWITCHTOPICK-UP": "انتقل إلى التحميل",
  "SWITCHTODROP-OFF": "انتقل إلى الإنزال",
  "FARTHEST": "الأبعد",
  "CLOSEST": "الأقرب",
  "PICK-UP": "تحميل",
  "DROP-OFF": "إنزال",
  "STUDENT": "طالب",
  "CANNOTBEADDEDTOTHEROUTE": "لا يمكن إضافته إلى المسار. يرجى التحقق مما إذا كان معطلا أو ليس لديه ولي أمر أساسي",
  "ADD": "إضافة",
  "ALREADYEXISTEDINSTOP#": "موجود بالفعل في التوقف رقم",
  "ALREADYEXISTEDINROUTE": ":موجود بالفعل في خط السير",
  "WOULDYOULIKETOADDTHISSTUDENTTOTHISROUTE": "هل ترغب في إضافة هذا الطالب إلى هذا المسار؟",
  "SUCCESSFULLYBEENASSIGNEDTOSTOP": "تم تعيينه بنجاح للتوقف رقم",
  "SUCCESS" : "تم حفظ الطريق بنجاح!",
  "DEACTIVATED": "معطل",
  "RESTORED": "استعادة",
  "ROUTESUCCESSFULLYCLONED": "تم استنساخ الطريق بنجاح!" ,
  "NATIONALITY": "الجنسية",
  "STATUS": "الحالة",
  "LICENSEEXPIRATION": "انتهاء صلاحية الرخصة",
  "ASSIGN": "تعيين",
  "ASSIGNING": "تعيين ...",
  "PLEASECONFIRM":"يرجى تأكيد",
  "NOTASSIGNED":"غيرمشارك",
  "MAKE": "الصنع",
  "MODEL": "النوع",
  "YEAR": "السنة",
  "SEATS": "مقاعد",
  "STOPMESSAGE1": "طالب {name} لا يمكن إضافتها إلى المسار. يرجى التحقق مما إذا كان معطلا أو ليس لديه ولي أمر أساسي",
  "STOPMESSAGE2": "{name} :موجود بالفعل في خط السير {route}. لا يمكن إضافة أثناء الوقت المحدد!",
  "STOPMESSAGE3": "طالب  {name} #موجود بالفعل في التوقف رقم {stop}",
  "STOPMESSAGE4": "طالب {name} {stop} # تم تعيينه بنجاح للتوقف '",
  "STOPMESSAGE5": "يبدو أن {name} يقع في موقع المدرسة ، يرجى إعادة تعيين الموقع الفعلي للطلاب أولاً!",
  "ROUTESUCCESSFULLY": "الطريق بنجاح",
  "UPLOADCSVFILE": "تحميل ملف CSV",
  "GENERATEROUTE": "توفير الطريق",
  "STUDENTID": "هوية الطالب",
  "INPROGRESS" :"في تَقَدم",
  "DELAYEDTHRESHOLD":"عتبة متاخرة",
  "ROUTEISOTIMIZED" :"الطريق محسنة",
  "FILLINFORMATION": "يرجى ملء علامة التبويب المعلومات أولاً"
}
} 
</i18n>
<template>
  <div class="form" id="route-manage">

    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <el-row>

          <span style="line-height: 36px;">{{$t('MANAGEROUTE')}} </span>
           <el-button
           :disabled="loading"
           :loading="saving || routing" 
           type="primary" 
           @click="save" >
           <i class="fa" v-if="!(saving || routing)" v-bind:class="submitIcon"></i> 
           {{submissionText}}
           </el-button>
          <el-button @click="$router.go(-1)">{{$t('CANCEL')}}</el-button>
        </el-row>
      </div>


      <el-col :span="8">

        <el-tabs class="formTab" type="border-card" v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('INFORMATION')">
            <VuePerfectScrollbar    ref="Scrollbar" class="scrollbar"  v-bind:style="{ height: (cardHeight - 40 ) + 'px' }">
            <el-form ref="infoForm" :model="schedule" label-width="120px" label-position="top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('DIRECTION')" prop="Direction" :rules="{type:'number', required:true, message:$t('ISREQUIRED'), trigger: 'blur,change'}">
                  <el-select v-model="schedule.Direction" @change="setDepature" :placeholder="$t('SELECTDIRECTION')">
                    <el-option
                      :key="index" 
                      v-for="(item, index) in directions"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="ServiceDate!=='0' ? $t('SELECTSERVICEDATE') : $t('SELECTTERM')">
                  <el-select v-model="ServiceDate" :placeholder="$t('SELECTTYPE')"   v-if="ServiceDate!==0">
                    <el-option
                      :label="$t('ACADEMICYEAR')"
                      :value="0">
                    </el-option>
                     <el-option
                      :label="$t('CUSTOMDATE')"
                      :value="1">
                    </el-option>
                  </el-select>
             <div class="el-input el-input-group el-input-group--prepend" v-if="ServiceDate === 0">
             <a class="el-input-group__prepend el-button el-icon-close" @click="ServiceDate=null"></a>
             <el-select :disabled="loading"  v-model="route.TermID" :placeholder="$t('SELECTACADEMICTERM')" @change="setTerm">
              <el-option
                :key="index" 
                v-for="(item, index) in terms"
                :label="item.year"
                :value="item.YearID">
              </el-option>
            </el-select>  
            </div>
                </el-form-item>

  

              </el-col>

            </el-row>


              <el-row>
                <el-col :span="11">
                  <el-form-item :label="$t('SERVICESTARTENDDATE')"  prop="StartDate" :rules="{type:'date',required:true, message:$t('ISREQUIRED'), trigger: 'blur,change'}">
                    <el-date-picker :disabled="ServiceDate === 0" type="date" v-model="schedule.StartDate" :format="date_format" :placeholder="$t('PICKADATE')"   style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2" align="center">-</el-col>
                <el-col :span="11">
                  <el-form-item :label="$t('SERVICESTARTENDDATE')"  prop="EndDate" :rules="{type:'date',required:true, message:$t('ISREQUIRED'), trigger: 'blur,change'}">
                    <el-date-picker  :disabled="ServiceDate === 0" type="date" v-model="schedule.EndDate" :format="date_format" :placeholder="$t('PICKADATE')"   style="width: 100%"></el-date-picker>
                  </el-form-item>
                 </el-col>
              </el-row>


            <el-row>
              <el-form-item :label="$t('DAYSINSERVICE')">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('CHECKALL')}}</el-checkbox>
            <div style="margin: 15px 0"></div>
            <el-checkbox-group v-model="schedule.ServiceDays" @change="handleCheckedDaysChange">
              <el-col :span="6" :key="key" v-for="(day, key) in daysC">
              <el-checkbox  :label="key.toString()">{{day}}</el-checkbox>
              </el-col>
            </el-checkbox-group>
              </el-form-item>
            </el-row>

              <el-row class="timing">
                <el-form-item :label="$t('HOMETOSCHOOLSERVICETIME')" :prop="!schedule.Time_AM_In ? 'Time_AM_In' : 'Time_AM_Out'" :rules="{required: (schedule.Direction == 1 || schedule.Direction == 3), message:$t('ISREQUIRED'), trigger: 'blur,change'}">
              <el-col :span="12">
              <el-time-select
                :placeholder="$t('STARTTIME')" size="small" :disabled="schedule.Direction === null || schedule.Direction === 2" v-model="schedule.Time_AM_In"  :picker-options="{start: '06:00', step: '00:15', end: '16:00'}">
              </el-time-select>
              </el-col>
                <el-col :span="12">
              <el-time-select
                :placeholder="$t('ENDTIME')" size="small" :disabled="schedule.Direction === null || schedule.Direction === 2" v-model="schedule.Time_AM_Out" :picker-options="{start: schedule.Time_AM_In, step: '00:15', end: '16:00', minTime: schedule.Time_AM_In}">

              </el-time-select>
              </el-col>
                </el-form-item>
                <el-form-item :label="$t('SCHOOLTOHOMESERVICETIME')" :prop="!schedule.Time_PM_In ? 'Time_PM_In' : 'Time_PM_Out'" :rules="{required: (schedule.Direction == 2 || schedule.Direction == 3), message:$t('ISREQUIRED'), trigger: 'blur,change'}">
              <el-col :span="12">
                <el-time-select
                  :placeholder="$t('STARTTIME')" size="small" :disabled="schedule.Direction === null || schedule.Direction === 1" v-model="schedule.Time_PM_In" :picker-options="{start: '06:00', step: '00:15', end: '16:00'}">
                </el-time-select>
              </el-col>
              <el-col :span="12">
                <el-time-select
                  :placeholder="$t('ENDTIME')" size="small" :disabled="schedule.Direction === null || schedule.Direction === 1" v-model="schedule.Time_PM_Out" :picker-options="{start: schedule.Time_PM_In, step: '00:15', end: '18:30', minTime: schedule.Time_PM_In}">

                </el-time-select>
              </el-col>
                </el-form-item>
              </el-row>

       
              <el-row :gutter="20">
                      <el-col :span="17">
                        <el-form ref="routeForm" :model="route" label-width="120px" label-position="top" style="padding: 0px !important;">
                        <el-form-item :label="$t('NAME')"  prop="TourName" :rules="[{required:true, message:$t('ISREQUIRED'), trigger: 'blur,change'},{max:15, message:$t('Maximum length should be 15 characters'), trigger: 'blur,change'}]">
                        <el-input
                          type="textarea"
                          v-model="route.TourName"
                          autosize
                          :placeholder="$t('PLEASEINPUT')">
                        </el-input>
                         </el-form-item>
                         </el-form>
                    </el-col>

                <el-col :span="7">



                    </el-col>

                </el-row>
                <el-row>
                <el-form-item :label="$t('DESCRIPTION')">
                <el-input
                  type="textarea"
                  v-model="route.Description"
                  :autosize="{minRows: 2, maxRows: 4}"
                  :placeholder="$t('PLEASEINPUT')"
                >
                </el-input>
                </el-form-item>
              </el-row>
            </el-form>
            </VuePerfectScrollbar>
          </el-tab-pane>
          <el-tab-pane :label="$t('STOPS')" :disabled="loading || stopTab">
            <el-row class="only-bottom-border">
                  <el-autocomplete
                    v-model="studentSearch"
                    :fetch-suggestions="querySearch"
                    :placeholder="$t('ADDSTUDENTTOASTOP')"
                    icon="search"
                    @select="addStudent"
                    style="display:block"
                    :trigger-on-focus="false"
                    ref="search"
                  autofocus> 
                  </el-autocomplete>

            </el-row>
        <el-row class="stopConfig" ref="config"  style="border-bottom: 1px solid rgb(204, 204, 204)">
                           <el-steps :space="100" style="height:30px" direction="vertical" :active="1">

                  <div class="el-step is-vertical">
                  <div class="el-step__head is-finish is-text" v-bind:style="{'background-color': direction.RouteColor, 'border-color': direction.RouteColor}">
                    <div class="el-step__line is-vertical" style="margin-right: 0px" v-bind:style="{'background-color': direction.RouteColor}">
                    <i class="el-step__line-inner" style="transition-delay: 0ms; height: 100%"></i></div>
                    <span class="el-step__icon">
                      <div><i class="fa fa-university"></i></div>
                    </span>
                  </div>
                  <div class="el-step__main">
                    <div class="el-step__title is-finish">

                 
                 
           
                       <el-color-picker style="margin-top:-5px" @change="setPathColor" v-model="direction.RouteColor"></el-color-picker>
        
           <el-button-group  class="btn-steps">
                  <el-button @click="route_ready(false)" :type="!is_manual ? 'primary' : 'default'" class="manual-stops" v-text="!is_manual ? 'Disable optimization' : 'Enable optimization'">

                   </el-button>
                <el-upload
                ref="upload"
                accept=".csv"                
                class="upload-csv"
                :action="URL + 'media/upload'"
                :data="import_data"
                :with-credentials="true"
                :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
                :on-success="uploadedFile"
                :on-progress="processUpload"
                :disabled="progress_import"
                >
                  <el-button  :loading="progress_import" type="default"> 
                    <i class="fa fa-upload"></i> {{ $t("UPLOADCSVFILE") }}
                    </el-button>
            
              </el-upload> 

              </el-button-group>
                    </div>
                    <div class="el-step__description is-finish"></div>

                  </div>

                </div>  
                </el-steps>
    </el-row>
    <el-row class="stop-steps"   v-loading="loaded || routing || progress_import" :element-loading-text="loadingMessage">
            <VuePerfectScrollbar   v-bind:style="{ height: stepsHeight + 'px' }"  ref="ScrollbarStops" class="scrollbar">
          <div ref="stops">
            <el-row ref="stops">

                            <el-steps :space="200" direction="vertical" :active="1">
  
                    <div align="center" v-show="moving_stop!=null && moving_stop != 1">
                      <el-button type="text" @click="moveStop(0)">
                        <span   transition="bounce"> Move selected stop here! </span>
                      </el-button>
                    </div>
               
              <div class="el-step is-vertical" :key="key" v-for="(stop, key) in listStops" v-if="key!=0">
                  <div class="el-step__head is-finish is-text" v-bind:style="{'background-color': direction.RouteColor, 'border-color': direction.RouteColor}">
                    <div class="el-step__line is-vertical" v-bind:style="{'background-color': direction.RouteColor}" >
                    <i class="el-step__line-inner" style="transition-delay: 0ms; height: 100%"></i></div>
                    <span class="el-step__icon">
                      <div v-text="key"></div>
                    </span>
                  </div>
                  <div class="el-step__main">
                    
                    <div class="el-step__title is-finish">
                      <span v-bind:style="{'text-decoration': stop.deleted ? $t('LINE-THROUGH') : $t('NONE')}"> 
                        <span>{{$t('STOP')}} {{(key)}}</span> 
                      </span>
                    <el-button v-if="is_manual" v-show="moving_stop == key || moving_stop == null" class="move-stop" size="mini" @click="movingStop(key)" v-text="moving_stop == key ? 'Cancel moving' :'Move stop'">
         
                      </el-button>

    

                   
          <el-card class="box-card" :body-style="{ padding: '0px' }">

                      <div slot="header" class="clearfix">
                        <el-row>
    
               <el-col :span="3" >

                 <el-popover class="stop-inputs" trigger="manual" v-model="stop.inputs" placement="right" width="400">
                   <el-form ref="form" :model="stop" label-width="120px" label-position="top">

                     <el-row>
                       <el-col :span="11">
                         <el-form-item :label="$t('GPSLATITUDE')">
                           <el-input v-model="stop.Lat">
                           </el-input>
                         </el-form-item>
                       </el-col>
                       <el-col :span="2">&nbsp</el-col>
                       <el-col :span="11">
                         <el-form-item :label="$t('GPSLONGITUDE')">
                           <el-input v-model="stop.Lng">
                           </el-input>
                         </el-form-item>
                       </el-col>
                     </el-row>
                     <el-row>
                       <el-form-item :label="$t('USEGOOGLEMAPDURATION')">
                         <el-radio class="radio" v-model="stop.mapDuration" :label="1">{{$t('YES')}}</el-radio>
                         <el-radio class="radio" v-model="stop.mapDuration" :label="0">{{$t('NO')}}</el-radio>
                       </el-form-item>
                     </el-row>

                     <el-row>
                       <el-col :span="11">
                         <el-form-item :label="$t('PREVIOUSWAITING')">
                           <el-input :disabled="stop.mapDuration ===0" v-model="stop.DeltaT">
                           </el-input>
                         </el-form-item>
                       </el-col>
                       <el-col :span="2">&nbsp</el-col>
                       <el-col :span="11">
                         <el-form-item :label="$t('STOPWAITING')">
                           <el-input :disabled="stop.mapDuration ===0" v-model="stop.WaitingTime">
                           </el-input>
                         </el-form-item>
                       </el-col>
                     </el-row>

                   </el-form>
                   <div class="popover-btn">
                     <el-button size="mini" type="text" @click="stop.inputs = false">{{$t('CANCEL')}}</el-button>
                     <el-button type="primary" size="mini" @click="stop.inputs = false">{{$t('CONFIRM')}}</el-button>
                   </div>
                   <el-button slot="reference"   @click="stop.inputs=true" icon="setting"></el-button>
                 </el-popover>
             </el-col>
             <el-col :span="18">

             </el-col>
            <el-col :span="3"> 
                  <el-button style="font-size:18px"  type="text" @click="deleteAction(stop, key)" :disabled="!noDragging">
                    <i class="fa" v-bind:class="[stop.deleted ? 'fa-undo' : 'fa-trash']"></i>
                  </el-button>

              </el-col>
            </el-row>


                      </div>
               <div align="center" v-if="!noDragging && dragged_list[key] == undefined" >
                <el-button   @click="dropList(key)" type="text">
                <i class="fa fa-arrow-circle-down"></i>
                  Move selected student(s) to this stop
                </el-button>
               </div>
                      <el-row  class="list" :key="index" v-for="(student, index) in stop.students" v-bind:class="{'dragged': isDragged(student, true)}">
              
                        <img :src="getAsset(student.ImagePath, 'student')" class="img-circle" style="width: 50px;">                  

                        <el-button type="text" size="large">
                          {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}
                          <i v-if="!stop.deleted && !isDragged(student, true)" @click="deleteAction(student, key)" class="fa" v-bind:class="[student.deleted ? 'fa-undo' : 'fa-remove']"></i>
                       
                        </el-button>
                        <el-button v-if="is_manual" type="text" @click="dragStudent(student)">
                          <i class="fa fa-exchange" data-fa-transform="rotate-180"></i> 
                          {{isDragged(student, true) ? 'Cancel' : 'Change stop' }}
                          </el-button>
                        <el-button v-bind:style="{color: direction.RouteColor}" class="mapPin" type="text" @click="pinStudentLocation(student)">
                          <i class="fa fa-map-pin fa-2x"></i>
                          </el-button>
                       
                      </el-row>
            <el-row v-if="stop.students!=undefined">
              <el-col v-if="stop.students.length == 0"  style="padding:10px; background-color: rgb(209, 219, 229); color:#4b4b4b"  align="center"><b>{{$t('NOSTUDENTSADDEDTOTHISSTOP')}}</b></el-col>
            </el-row>


                        <el-row class="only-top-border">

                        </el-row>
                    </el-card>
                    <div align="center" v-show="moving_stop!=null && moving_stop != key && moving_stop != key + 1">
                      <el-button type="text" @click="moveStop(key)">
                        <span   transition="bounce"> Move selected stop here! </span>
                      </el-button>
                    </div>
                    </div>
                    <div class="el-step__description is-finish"></div>

                  </div>

                </div>

              </el-steps>
            </el-row>
          </div>
              </VuePerfectScrollbar>
                  </el-row>
             </el-tab-pane>

          <el-tab-pane v-if="isAllowed('registration')" :label="$t('REGISTRATION')" :disabled="loaded || registrationTab">
            <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"  v-bind:style="{ height: tabHeight - 3 + 'px' }">
              <el-row style="padding:5px" >
    
            <h4>{{$t('SUPERVISOR')}}</h4>
            <el-row class="list">
            <img :src="getAsset(monitor.ImagePath, 'supervisor')"  class="img-circle" style="width: 50px;">
            {{_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})}}  <el-checkbox v-model="selectedMonitor" :disabled="!isAllowed('registration', 'transportation/supervisor')" style="float:right"  :label="monitor.BusMonitorID">&nbsp</el-checkbox><br/>
            </el-row>
            <h4 v-if="driver.EMail">{{$t('DRIVER')}}</h4>
            <el-row v-if="driver.EMail" class="list">
            <img :src="getAsset(driver.ImagePath, 'driver')"  class="img-circle" style="width: 50px;">
            {{_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})}}  <el-checkbox v-model="tickedDriver" :disabled="!isAllowed('registration', 'transportation/driver')" style="float:right"  :label="driver.BusDriverID">&nbsp</el-checkbox><br/>
            </el-row>            
             <el-checkbox-group v-model="selectedStudents" style="padding-right:10px">
            <h4>{{$t('STUDENTS')}}</h4>

            <div :key="index" v-for="(stop, index) in stops">
            <el-row  class="list" :key="index" v-for="(student, index) in stop.students">
              <img :src="getAsset(student.ImagePath, 'student')"  class="img-circle" style="width: 50px;">
            {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}} 
            <el-checkbox style="float:right" :label="student.StudentID">&nbsp;</el-checkbox><br/>
            </el-row>
            </div>
                </el-checkbox-group>
              </el-row>
            </VuePerfectScrollbar>
            <el-button type="primary" @click="sendRegistration" :loading="sending" :disabled="selectedStudents.length === 0 && !selectedMonitor && !tickedDriver" style="height:40px; display: block; width:100%; border-radius: 0"> {{sending ? $t('SENDING') : $t('SENDREGISTRATIONCODE')}}</el-button>
          </el-tab-pane>
<el-tab-pane :label="$t('SETTINGS')" v-if="route.TourID"  :disabled="loading">
<el-form  style="padding:10px" label-width="120px" label-position="top">
<el-row>
<el-form-item :label="$t('STATUS')">
<el-switch
  v-model="route.Deleted"
  :disabled="!isAllowed('status')"
  on-value="0"
  off-value="1"
  :on-text="$t('ACTIVE')"
  :off-text="$t('INACTIVE')"
  :width="80"
  @change="status">
</el-switch>
</el-form-item>
 </el-row>
<el-row>
 <el-form-item :label="$t('COPYROUTE')">
 <el-input :placeholder="$t('NAMEYOURROUTE')" v-model="clonedName" :disabled="!isAllowed('clone')">
    <el-button :disabled="!clonedName && !isAllowed('clone')" slot="append" :loading="cloning"  @click="cloneRoute">{{cloning ? $t('CLONING') : $t('MAKEACOPY')}}</el-button>
    </el-input>

</el-form-item>
         </el-row>

                       <el-col :span="12">
                          <el-form-item :label="$t('DELAYEDTHRESHOLD')">
                <el-time-select
                  :placeholder="$t('STARTTIME')" 
                  size="small" 
                  v-model="schedule.DelayedThreshold" 
                  :picker-options="{start: '00:05', step: '00:5', end: '00:30'}"
                  format="hh:mm"
                  >
                </el-time-select>
                </el-form-item>
              </el-col>
</el-form>
 
          </el-tab-pane>
        </el-tabs>



      </el-col>
      <el-col :span="16"  v-loading="loading" :element-loading-text="$t('LOADING')">

        <el-tabs class="staff" type="border-card" v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('OVERVIEW')">
            <el-form id="OVForm" ref="OVForm" :model="route" :inline="true">
            <el-row  :gutter="20">
              <el-col :span="8" class="border1">
               <el-form-item prop="BusID" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change,blur'}">
                <div slot="label" style="display:inline-block;"><i class="fa fa-bus fa-3x"></i>
                 <el-tag># {{bus.Label}}</el-tag>
                 </div>
                  <el-tooltip effect="dark" :disabled="!stopTab" :content="$t('FILLINFORMATION')" placement="top">
                    <span class="wrapper el-button"><el-button @click="getBuses" :disabled="stopTab" size="small" :icon="route.TourID!==null ? 'edit' : 'plus'">{{$t('BUS')}}</el-button></span>
                  </el-tooltip>
                </el-form-item>
             </el-col>
              <el-col :span="8" class="border2">
                <el-form-item prop="BusMonitorID" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change,blur'}">
                  <div slot="label"><img :src="getAsset(monitor.ImagePath, 'supervisor')" class="img-circle">
                    <div style="display: flex;"><el-tooltip placement="top" :disabled="!ellipsis" :content="_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR}) === undefined ? '&zwnj;' : _FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})"><span v-on:mouseover="isEllipsisActive" class="overflow-text">{{_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR}) === undefined ? '&zwnj;' : _FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})}}</span></el-tooltip></div>
                  </div>
                  <el-tooltip effect="dark" :disabled="!stopTab" :content="$t('FILLINFORMATION')" placement="top">
                    <span class="wrapper el-button"><el-button @click="getSupervisors" :disabled="stopTab" size="small" :icon="route.TourID!==null ? 'edit' : 'plus'">{{$t('SUPERVISOR')}}</el-button></span>
                  </el-tooltip>                  
                </el-form-item>                
             </el-col>
              <el-col :span="8">
                <el-form-item prop="BusDriverID" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change,blur'}">
                  <div slot="label"><img :src="getAsset(driver.ImagePath, 'driver')" class="img-circle">
                    <div style="display: flex;"><el-tooltip placement="top" :disabled="!ellipsis" :content="_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR}) === undefined ? '&zwnj;' : _FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})"><span v-on:mouseover="isEllipsisActive" class="overflow-text">{{_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR}) === undefined ? '&zwnj;' : _FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})}}</span></el-tooltip></div>
                  </div>
                  <el-tooltip effect="dark" :disabled="!stopTab" :content="$t('FILLINFORMATION')" placement="top">
                    <span class="wrapper el-button"><el-button @click="getDrivers" :disabled="stopTab" size="small" :icon="route.TourID!==null ? 'edit' : 'plus'">{{$t('DRIVER')}}</el-button></span>
                  </el-tooltip>                  
                  
                </el-form-item>                
             </el-col>
            </el-row>
            </el-form>
            <el-row style="height:15px"></el-row>
            <el-row  style="position:relative;  margin:0 -15px;">
            <div id="gmap-route" v-bind:style="{ height: cardHeight - 122 + 'px' }"></div>
            </el-row>

          </el-tab-pane>
          <el-tab-pane label="Trips" v-if="false">{{$t('TRIPS')}}</el-tab-pane>
          <el-tab-pane label="Violations" v-if="false">{{$t('VIOLATIONS')}}</el-tab-pane>
          <el-tab-pane label="Incidents" v-if="false">{{$t('INCIDENTS')}}</el-tab-pane>

        </el-tabs>

      </el-col>

          </el-card>
     <el-dialog @close="clearSelections()" :title="$t('SELECTBUS')" v-model="showBuses" size="small">
       <h4>{{$t('SELECTEDBUS')}}</h4>
       <el-row class="list">
         <el-tag># {{bus.Label}}</el-tag>

       </el-row>
       <h4>{{$t('AVAILABLEBUSES')}}</h4>

             <el-table
       v-loading="loadingBuses"   
       :default-sort="{prop: 'RouteID'}" 
        :element-loading-text="$t('LOADING')"
        :data="filteredData"
        highlight-current-row
        :height="500"
        stripe
        style="width: 100%">
        <el-table-column
          prop="Label"
          :render-header="headerFilter"
          min-width="135"
          :label="$t('BUSNUMBER')"
          align="left"
          >
        </el-table-column>
        <el-table-column
          prop="Model"
          :label="$t('MODEL')"
          min-width="95"
          align="left"
          sortable>
        </el-table-column>
        <el-table-column
          prop="Year"
          :label="$t('YEAR')"
          align="center"
          min-width="90"
          sortable>
        </el-table-column>

        <el-table-column
          prop="MaxSeats"
          :label="$t('SEATS')"
          align="center"
          min-width="90"
          sortable>
        </el-table-column>

       <el-table-column
           :label="$t('STATUS')"
          align="center"
          prop="RouteID"
          min-width="100"
          sortable>
          <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.RouteID==null">{{$t('NOTASSIGNED')}}</el-tag>
          </template>
        </el-table-column>

         <el-table-column
          label=""
          min-width="100"
          align="center"
          class="actions">

          <template slot-scope="scope">
            <el-button v-if="scope.row.BusID !== route.BusID" :loading="assigning[scope.row.BusID]" @click="assignProcess(scope.row.BusID, scope.row.Label, 'Bus')" :type="selectedBus==scope.row.BusID  ? 'primary' : 'default'">
            {{$t(selectedBus==scope.row.BusID ? 'PLEASECONFIRM' : assigning[scope.row.BusID] ? 'ASSIGNING' : 'ASSIGN')}}
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showBuses = item_checked = false">{{$t('CANCEL')}}</el-button>
        <el-button type="primary" @click="setBus" :disabled="selectedBus === route.BusID || selectedBus ===null">{{$t('CONFIRM')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog @close="clearSelections()" :title="$t('SELECTDRIVER')" v-model="showDrivers" size="small">
      <h4>{{$t('SELECTEDDRIVER')}}</h4>
      <el-row class="list">
        <img :src="getAsset(driver.ImagePath, 'driver')"  class="img-circle" style="width: 50px;">
        {{_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})}}
            </el-row>
      <h4>{{$t('AVAILABLEDRIVERS')}}</h4>

            <el-table
       v-loading="loadingDrivers"   
       :default-sort="{prop: 'RouteID'}" 
        :element-loading-text="$t('LOADING')"
        :data="filteredData"
        highlight-current-row
        :height="500"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          :render-header="headerFilter"
          min-width="150"
          prop="FullName_EN"
          align="left"
          >
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath, 'driver')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR}) + $t('')}}
          </template>
        </el-table-column>
                <el-table-column
          prop="LicenseExpiration"
          :label="$t('LICENSEEXPIRATION')"
          min-width="145"
          align="center">
        </el-table-column>
        <el-table-column
          :label="$t('NATIONALITY')"
          min-width="102"
          align="left">
          <template slot-scope="scope">
            {{$countries[scope.row.Nationality]}}
          </template>
        </el-table-column>
       <el-table-column
          :label="$t('STATUS')"
          min-width="108"
           prop="RouteID"
          align="center"
          sortable>

          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.RouteID==null">{{$t('NOTASSIGNED')}}</el-tag>

          </template>
        </el-table-column>

         <el-table-column
          label=""
          min-width="95"
          align="center"
          class="actions">

          <template slot-scope="scope">
            <el-button v-if="scope.row.BusDriverID !== route.BusDriverID" :loading="assigning[scope.row.BusDriverID]" @click="assignProcess(scope.row.BusDriverID, _FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR}), 'Driver')" :type="selectedDriver==scope.row.BusDriverID  ? 'primary' : 'default'">
            {{$t(selectedDriver==scope.row.BusDriverID ? 'PLEASECONFIRM' : assigning[scope.row.BusDriverID] ? 'ASSIGNING' : 'ASSIGN')}}
            </el-button>

          </template>
        </el-table-column>

      </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="showDrivers = item_checked= false">{{$t('CANCEL')}}</el-button>
      <el-button type="primary" @click="setDriver"  :disabled="selectedDriver === route.BusDriverID || selectedDriver ===null">{{$t('CONFIRM')}}</el-button>
    </span>
    </el-dialog>

    <el-dialog @close="clearSelections()" :title="$t('SELECTSUPERVISOR')" :callback="clearEverything" v-model="showSupervisors" size="small">
      <h4>{{$t('SELECTEDSUPERVISOR')}}</h4>
      <el-row class="list">
        <img :src="getAsset(monitor.ImagePath, 'supervisor')"  class="img-circle" style="width: 50px;">
        {{_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})}}
            </el-row>
      <h4>{{$t('AVAILABLESUPERVISORS')}}</h4>
            <el-table
       v-loading="loadingSupervisors"   
       :default-sort="{prop: 'RouteID'}" 
        :element-loading-text="$t('LOADING')"
        :data="filteredData"
        highlight-current-row
        :height="500"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          :render-header="headerFilter"
          min-width="200"
          prop="FullName_EN"
          align="left"
          >
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.ImagePath, 'supervisor')" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})  + $t('')}}
          </template>
        </el-table-column>
 
        <el-table-column
          :label="$t('NATIONALITY')"
          min-width="150"
          align="left"
          sortable>
          <template slot-scope="scope">
            {{$countries[scope.row.Nationality]}}
          </template>
        </el-table-column>
       <el-table-column
          :label="$t('STATUS')"
          min-width="120"
           prop="RouteID"
          align="center"
          sortable>

          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.RouteID==null">{{$t('NOTASSIGNED')}}</el-tag>

          </template>
        </el-table-column>

         <el-table-column
          label=""
          min-width="120"
          align="center"
          class="actions">

          <template slot-scope="scope">
            <el-button v-if="scope.row.BusMonitorID !== route.BusMonitorID" :loading="assigning[scope.row.BusMonitorID]" @click="assignProcess(scope.row.BusMonitorID, _FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR}), 'Supervisor')" :type="selectedSupervisor==scope.row.BusMonitorID  ? 'primary' : 'default'">
            {{$t(selectedSupervisor==scope.row.BusMonitorID  ? 'PLEASECONFIRM' : assigning[scope.row.BusMonitorID] ? 'ASSIGNING' : 'ASSIGN')}}
            </el-button>

          </template>
        </el-table-column>

      </el-table>

   <span slot="footer" class="dialog-footer">
    <el-button @click="showSupervisors = item_checked= false">{{$t('CANCEL')}}</el-button>
    <el-button type="primary" @click="setSupervisor"  :disabled="selectedSupervisor === route.BusMonitorID || selectedSupervisor === null">{{$t('CONFIRM')}}</el-button>
  </span>
    </el-dialog>

      <el-dialog
      :title="$t('ERROR')"
      v-model="error"
      size="tiny">

  <div class="el-alert el-alert--error">
    <i class="el-alert__icon el-icon-circle-cross is-big"></i>
    <div class="el-alert__content">
      <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
      </div>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>

  </div>
</template>
<script>
  import axios from 'axios'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  let clusterMaker = require('clusters')
  export default {
    components: {VuePerfectScrollbar},
    data () {
      return {
        MAXIMUM_WAYPOINT_LIMIT: 8,
        DEG_TO_RAD: 0.017453292519943295769236907684886,
        EARTH_RADIUS_IN_METERS: 6372797.560856,
        EARTH_RADIUS_IN_MILES: 3959,
        METERS_TO_MILES: 0.000621371192,
        infoIndex: null,
        infoOptions: {pixelOffset: {width: 0, height: -35}},
        route: {
          TourID: null,
          bus: {},
          driver: {},
          monitor: {},
          Deleted: false
        },
        schedule: {
          TourID: null,
          Direction: null,
          ServiceDays: [],
          StartDate: null,
          EndDate: null,
          Time_AM_In: null,
          Time_AM_Out: null,
          Time_PM_In: null,
          Time_PM_Out: null,
          DelayedThreshold: '00:05'
        },
        direction: {
          TourID: null,
          TermID: null,
          RouteColor: '#4b4b4b',
          Snapshot: null,
          DraftAuthor: null,
          Updated: null,
          Polyline: [],
          IsManual: 1
        },
        bus: {},
        driver: {},
        monitor: {},
        term: {},
        students: {},
        coordinates: {},
        school: {},
        center: {},
        deleted_students: {},
        stops: [],
        student_search: [],
        terms: [],
        checkedDays: [],
        selectedStudents: [],
        days: [],
        buses: [],
        drivers: [],
        supervisors: [],
        markers: [],
        pin_location: null,
        animate_stop: null,
        autoSource: null,
        DraftAuthor: null,
        clonedName: null,
        student: null,
        studentSearch: null,
        selected_stop: null,
        Location: null,
        timeout: null,
        select_search: null,
        selectedBus: null,
        selectedDriver: null,
        selectedSupervisor: null,
        mapDuration: null,
        directionsService: null,
        directionsDisplay: null,
        polyline: null,
        message: null,
        maps: null,
        map: null,
        list: null,
        country: 'AE',
        date_format: 'dd/MM/yyyy',
        CSVFile: '',
        activeIndex: '',
        handleSelect: '',
        dialogImageUrl: '',
        loading: false,
        dialogVisible: false,
        checkAll: false,
        isIndeterminate: false,
        showBuses: false,
        showDrivers: false,
        showSupervisors: false,
        loadingBuses: true,
        loadingDrivers: true,
        loadingSupervisors: true,
        selectedMonitor: false,
        tickedDriver: false,
        pinMap: false,
        error: false,
        saving: false,
        item_checked: false,
        driver_checked: false,
        bus_checked: false,
        sending: false,
        assigning: {},
        cloning: false,
        loaded: false,
        dialogImport: false,
        import_data: {},
        progress_import: false,
        routing: false,
        is_ready: true,
        polylineIndex: 0,
        timer: 0,
        ServiceDate: 1,
        stepsHeight: 0,
        pickup: 0,
        dropoff: 0,
        departure: 0,
        cardHeight: 0,
        tabHeight: 0,
        current_stop: 0,
        direction_order: 0,
        active_direction: 0,
        drafted_stops: 0,
        deleted_stops: 0,
        filteredData: [],
        typed: '',
        ellipsis: false,
        dragged_list: {},
        moving_stop: null,
        is_manual: false,
        clusters_distance: {},
        cluster_index: 0,
        stops_order: []
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.DraftAuthor = userData.user_id
      this.import_data = {folder: this.$route.path.split('/')[2], type: 'import'}
      this.school = this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.tabHeight = this.cardHeight - 78
      this.stepsHeight = this.tabHeight - 60
      let self = this
      this.$google.then(function (Maps) {
        let position = new Maps.LatLng(self.center)
        self.maps = Maps
        self.map = new Maps.Map(document.getElementById('gmap-route'), {
          center: position,
          zoom: 14
        })
        self.markers[0] = self.addMarker(position, 0, null)
        self.markers[0].setMap(self.map)
        self.initMap()
        self.stops[0] = {
          originLat: self.center.lat,
          originLng: self.center.lng,
          Lat: self.center.lat,
          Lng: self.center.lng,
          DeltaT: 0,
          Distance: 0,
          Duration: 0,
          mapDuration: 0,
          WaitingTime: 0,
          inputs: false,
          deleted: false,
          draft: true,
          polyline: null,
          stop_id: 0,
          students: []
        }
        let key = self.center.lat + ',' + self.center.lng
        self.coordinates[key] = 0
        self.getRoute()
      })
      this.getAcademicTerms()
    },
    computed: {
      stopTab () {
        let disabledAM = true
        let disabledPM = true
        if (this.schedule.Time_AM_In !== undefined && this.schedule.Time_AM_Out !== undefined) disabledAM = false
        if (this.schedule.Time_PM_In !== undefined && this.schedule.Time_PM_Out !== undefined) disabledPM = false
        if ((this.schedule.Direction === 3) && !disabledAM && !disabledPM) return false
        if ((this.schedule.Direction === 1 && !disabledAM) || (this.schedule.Direction === 2 && !disabledPM)) return false
        return true
      },
      registrationTab () {
        if (Object.keys(this.stops).length < 2 || this.monitor.BusMonitorID === undefined || this.driver.BusDriverID === undefined) return true
        return false
      },
      submitIcon () {
        if (this.loading) return
        if ((this.route.TourID === null && this.stops.length <= 1) || this.route_ready(true)) return 'fa-check'
        return 'fa-road'
      },
      submissionText () {
        let text = 'GENERATEROUTE'
        if (this.routing) text = 'INPROGRESS'
        if ((this.route.TourID === null && this.stops.length <= 1) || this.stops.length === 1) text = 'SAVE'
        if (this.direction.Polyline !== null && this.route_ready(true) && !this.routing) text = 'SAVE'
        if (this.direction.Polyline !== null && this.saving) text = 'SAVING'
        return this.$t(text)
      },
      tooltipText (num) {
        if (this.departure === 1) return this.$t('SWITCHTOPICK-UP') + ' ' + (this.pickup !== 1 ? this.$t('FARTHEST') : this.$t('CLOSEST'))
        if (this.departure === 0) return this.$t('SWITCHTODROP-OFF') + ' ' + (this.dropoff !== 1 ? this.$t('FARTHEST') : this.$t('CLOSEST'))
      },
      loadingMessage () {
        if (this.routing) return this.$t('INPROGRESS')
        if (!this.loaded || this.progress_import) return this.$t('LOADING')
      },
      listStops () {
        return this.stops
      },
      daysC () {
        return (this.days = [
          this.$t('MONDAY'),
          this.$t('TUESDAY'),
          this.$t('WEDNESDAY'),
          this.$t('THURSDAY'),
          this.$t('FRIDAY'),
          this.$t('SATURDAY'),
          this.$t('SUNDAY')
        ])
      },
      directions () {
        let directions = [{
          value: 1,
          label: this.$t('HOMETOSCHOOL')
        }, {
          value: 2,
          label: this.$t('SCHOOLTOHOME')
        }, {
          value: 3,
          label: this.$t('BOTH(ROUNDTRIP)')
        }]
        return directions
      },
      fields () {
        return [
          {label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null},
          {label: this.$t('GPSLATITUDE'), field: 'lat', required: true, format: null},
          {label: this.$t('GPSLONGITUDE'), field: 'lng', required: true, format: null}
        ]
      },
      selectedModal () {
        let selected = {}
        if (this.showBuses) selected = {data: this.buses, filter: 'Label', placeholder: this.$t('BUSNUMBER')}
        else if (this.showDrivers) selected = {data: this.drivers, filter: ['FullName_EN', 'FullName_AR'], placeholder: this.$t('NAME')}
        else if (this.showSupervisors) selected = {data: this.supervisors, filter: ['FullName_EN', 'FullName_AR'], placeholder: this.$t('NAME')}
        return selected
      },
      noDragging () {
        if (Object.keys(this.dragged_list).length === 0) return true
        return false
      }
    },
    methods: {
      toggleMoving () {
      },
      movingStop (stop) {
        if (this.moving_stop === stop) return (this.moving_stop = null)
        this.moving_stop = stop
      },
      moveStop (destination) {
        let key = 0
        if (destination < this.moving_stop) key = 1
        let _stop = this.stops[this.moving_stop]
        this.$delete(this.stops, this.moving_stop)
        this.stops.splice(destination + key, 0, _stop)
        for (let stop in this.stops) {
          let students = this.stops[stop].students
          for (let student in students) {
            let StudentID = students[student].StudentID
            this.students[StudentID] = stop
          }
        }
        this.drawMarkers(this.stops)
        this.route_ready(true)
        this.dragged_list = {}
        this.moving_stop = null
      },
      isDragged (student, option) {
        let stop = this.students[student.StudentID]
        if (this.dragged_list[stop] === undefined) {
          let _stop = {}
          _stop[stop] = {}
          if (option === undefined) this.dragged_list = Object.assign({}, this.dragged_list, _stop)
          return false
        }
        if (this.dragged_list[stop][student.StudentID] !== undefined) return true
        return false
      },
      dragStudent (student) {
        let isDragged = this.isDragged(student, true)
        if ((this.stops.length - Object.keys(this.dragged_list).length === 2) && !isDragged) return
        let stop = this.students[student.StudentID]
        let _item = {}
        _item[student.StudentID] = student
        if (!this.isDragged(student)) return (this.dragged_list[stop] = Object.assign({}, this.dragged_list[stop], _item))
        this.$delete(this.dragged_list[stop], student.StudentID)
        if (Object.keys(this.dragged_list[stop]).length === 0) this.$delete(this.dragged_list, stop)
      },
      dropList (stop) {
        if (Object.keys(this.dragged_list).length === 0) return
        for (let item in this.dragged_list) {
          let students = this.dragged_list[item]
          for (let student in students) {
            this.stops[stop].students.push(students[student])
            this.removeStudent(student)
            this.students[student] = stop
          }
          this.$delete(this.dragged_list, item)
        }
      },
      removeStudent (StudentID) {
        let stop = this.students[StudentID]
        this.$delete(this.dragged_list[stop], StudentID)
        let students = this.stops[stop].students
        for (let student in students) {
          if (students[student].StudentID === StudentID) return (this.$delete(this.stops[stop].students, student))
        }
      },
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      headerFilter (h, obj) {
        return h('el-input', {props: {value: this.typed}, attrs: {class: 'header-search', placeholder: this.selectedModal.placeholder}, on: {change: val => { this.filteredData = !val ? this.selectedModal.data : this.filterBy(this.selectedModal.data, val, this.selectedModal.filter) }}})
      },
      filterBy (arr, search, delimiter) {
        if (!search) return arr
        let res = []
        arr.filter(function (el) {
          if (typeof delimiter === 'object') {
            let regx = new RegExp('(?:^|\\s)' + search, 'ig')
            if (regx.test(el[delimiter[0]]) || regx.test(el[delimiter[1]])) res.push(el)
          } else {
            search = '^' + search
            if (new RegExp(search, 'i').test(el[delimiter])) res.push(el)
          }
        })
        return res
      },
      currentStops () {
        let stops = null
        if (this.departure === 1) stops = (this.pickup === 1 ? this.farthest_stops : this.closest_stops)
        if (this.departure === 0) stops = (this.dropoff === 1 ? this.farthest_stops : this.closest_stops)
        return stops
      },
      hideStep (key) {
        if (this.direction_order === 0 && key !== 0) return true
        if (this.direction_order === 1 && key !== this.stops.length - 1) return true
        return false
      },
      buttonText () {
        if (this.departure === 1) return this.$t('PICK-UP') + ' ' + (this.pickup !== 0 ? this.$t('FARTHEST') : this.$t('CLOSEST'))
        if (this.departure === 0) return this.$t('DROP-OFF') + ' ' + (this.dropoff !== 0 ? this.$t('FARTHEST') : this.$t('CLOSEST'))
      },
      tabStudent (student) {
        let key = this.selectedStudents.indexOf(student)
        if (key < 0) return this.selectedStudents.push(student)
        delete this.selectedStudents[key]
      },
      handleCheckAllChange (event) {
        let days = []
        for (let day in this.days) {
          days.push(day)
        }
        this.schedule.ServiceDays = event.target.checked ? days : []
        this.isIndeterminate = false
      },
      handleCheckedDaysChange (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.days.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.days.length
      },
      setPlace (place) {
        this.stops[this.current_stop].lat = place.geometry.location.lat()
        this.stops[this.current_stop].lng = place.geometry.location.lng()
        this.$refs.mapCard.panTo({lat: place.geometry.location.lat(), lng: place.geometry.location.lng()})
        this.updateDirection()
      },
      findStudent (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=route', {cancelToken: this.autoSource.token})
      },
      querySearch (queryString, cb) {
        let self = this
        if (queryString === null || queryString === '') return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findStudent(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      addStudent (data) {
        this.student = data
        this.studentSearch = null
        let self = this
        if (data.student.Lat === this.school.lat && data.student.Lng === this.school.lng) {
          return self.$alert(this.$t('STOPMESSAGE5', {name: data.value}), this.$t('ADD') + ' ' + this.$t('STUDENT'), {showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close'}).then((res) => {}, (reason) => { this.$nextTick(() => this.$refs.search.$el.children[0].lastElementChild.focus()) })
        }
        if (data.student.Status !== null || data.student.IsMain === null) {
          return self.$alert(this.$t('STOPMESSAGE1', {name: data.value}), this.$t('ADD') + ' ' + this.$t('STUDENT'), {showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close'}).then((res) => {}, (reason) => { this.$nextTick(() => this.$refs.search.$el.children[0].lastElementChild.focus()) })
        }
        if (this.checkStop()) return
        this.checkRoute(data.student.StudentID).then(function (response) {
          let result = response.data
          if (result.TourID === undefined) return self.assignStop()
          self.$alert(self.$t('STUDENT') + ' ' + self.$t('STOPMESSAGE2', {name: data.value, route: result.TourName}), self.$t('ADD') + ' ' + self.$t('STUDENT'), {showCancelButton: true, cancelButtonText: 'Close', showConfirmButton: false}).then((res) => {}, (reason) => { self.$nextTick(() => self.$refs.search.$el.children[0].lastElementChild.focus()) })
        }).catch(function () {
        })
      },
      assignProcess (id, name, type) {
        this.$set(this.assigning, id, true)
        let self = this
        this.checkRoute(id, type).then(function (response) {
          self.$set(self.assigning, id, false)
          let result = response.data
          if (result.TourID === undefined) {
            switch (type) {
              case 'Bus': self.selectedBus = id
                break
              case 'Supervisor': self.selectedSupervisor = id
                break
              case 'Driver': self.selectedDriver = id
                break
            }
          } else self.$alert(self.$t(type.toUpperCase()) + ' ' + self.$t('STOPMESSAGE2', {name: name, route: result.TourName}), self.$t('ADD') + ' ' + self.$t(type.toUpperCase()), {showCancelButton: true, cancelButtonText: 'Close', showConfirmButton: false}).then((res) => {}, (reason) => { self.$nextTick(() => self.$refs.search.$el.children[0].lastElementChild.focus()) })
        }).catch(function () {
        })
      },
      checkRoute (id, type = 'Student') {
        let self = this
        let params = {
          TourID: self.route.TourID,
          ID: id,
          Type: type,
          ServiceDays: this.schedule.ServiceDays,
          StartDate: this.$moment(this.schedule.StartDate).format('YYYY-MM-DD'),
          EndDate: this.$moment(this.schedule.EndDate).format('YYYY-MM-DD')
        }
        if (this.schedule.Time_AM_In && (this.schedule.Direction === 1 || this.schedule.Direction === 3)) {
          params.Time_AM_In = this.schedule.Time_AM_In
          params.Time_AM_Out = this.schedule.Time_AM_Out
        }
        if (this.schedule.Time_PM_In && (this.schedule.Direction === 2 || this.schedule.Direction === 3)) {
          params.Time_PM_In = this.schedule.Time_PM_In
          params.Time_PM_Out = this.schedule.Time_PM_Out
        }
        return this.$http.get('/route/check', {params: params})
      },
      checkStop () {
        let student = this.student.student
        if (this.students[student.StudentID] !== undefined) {
          this.$alert(this.$t('STOPMESSAGE3', {name: this.student.value, stop: this.students[student.StudentID]}), this.$t('ADD') + ' ' + this.$t('STUDENT'), {showConfirmButton: false, showCancelButton: true, cancelButtonText: 'Close'}).then((res) => {}, (reason) => { this.$nextTick(() => this.$refs.search.$el.children[0].lastElementChild.focus()) })
          return true
        }
        for (let stop in this.stops) {
          let students = this.stops[stop].students
          for (let item in students) {
            if (students[item].Lat === student.Lat && students[item].Lng === student.Lng) {
              student.draft = true
              this.students[student.StudentID] = stop
              this.stops[stop].students.push(student)
              this.$nextTick(() => this.$refs.search.$el.children[0].lastElementChild.focus())
              this.$message({message: this.$t('STOPMESSAGE4', {name: this.student.value, stop: stop}), type: 'success'})
              return true
            }
          }
        }
        return false
      },
      assignStop () {
        let student = this.student.student
        student.draft = true
        student.deleted = false
        let stop = this.stops.length
        this.students[student.StudentID] = stop
        let extra = {
          DeltaT: 0,
          Distance: 0,
          Duration: 0,
          Lat: parseFloat(student.Lat),
          Lng: parseFloat(student.Lng),
          WaitingTime: 0,
          deleted: false,
          draft: true,
          inputs: false,
          mapDuration: 0,
          originLat: parseFloat(student.Lat),
          originLng: parseFloat(student.Lng),
          polyline: null,
          stop_id: stop,
          students: [student]
        }
        let key = student.Lat + ',' + student.Lng
        this.coordinates[key] = stop
        this.is_ready = false
        this.stops.push(extra)
        this.drafted_stops++
        let position = new this.maps.LatLng(extra.Lat, extra.Lng)
        this.markers[stop] = this.addMarker(position, stop, this.direction.RouteColor)
        this.markers[stop].setMap(this.map)
        this.pinStudentLocation(student)
        this.scrollDown()
        this.$nextTick(() => this.$refs.search.$el.children[0].lastElementChild.focus())
      },
      insertStop (current) {
        let newStop = Object.assign({}, this.stops[current])
        newStop.student = []
        this.stops.splice(current, 0, newStop)
        for (let stop in this.stops) {
          this.stops[stop].Stop = stop
          this.stops[stop] = Object.assign({}, this.stops[stop])
        }
      },
      getBuses () {
        this.filteredData = []
        this.showBuses = true
        this.$refs.OVForm.validateField('BusID')
        let self = this
        if (self.buses.length !== 0) return (self.filteredData = self.buses)
        this.$http.get('/bus').then(function (response) {
          self.buses = self.filteredData = response.data
          self.loadingBuses = false
        }).catch(function (response) {})
      },
      getDrivers () {
        this.filteredData = []
        this.showDrivers = true
        this.$refs.OVForm.validateField('BusDriverID')
        let self = this
        if (self.drivers.length !== 0) return (self.filteredData = self.drivers)
        this.$http.get('/driver').then(function (response) {
          self.drivers = self.filteredData = response.data
          self.loadingDrivers = false
        }).catch(function (response) {})
      },
      getSupervisors () {
        this.filteredData = []
        this.showSupervisors = true
        this.$refs.OVForm.validateField('BusMonitorID')
        let self = this
        if (self.supervisors.length !== 0) return (self.filteredData = self.supervisors)
        this.$http.get('/supervisor').then(function (response) {
          self.supervisors = self.filteredData = response.data
          self.loadingSupervisors = false
        }).catch(function (response) {})
      },
      isEllipsisActive (e) {
        this.ellipsis = e.target.clientWidth < e.target.scrollWidth
      },
      updateDirection () {
        let self = this
        let postData = {stops: this.stops}
        this.$http.post('/route/path', postData).then(function (response) {
          self.route.path = response.data
        }).catch(function (response) {})
      },
      reAssignStops () {
        let studentsStops = {}
        let stops = []
        let _stops = []
        for (let stop in this.stops) {
          stop = parseInt(stop)
          let students = this.stops[stop].students
          if (!this.stops[stop].deleted) {
            stops[stop] = {}
            stops[stop].WaitingTime = students.length
            stops[stop].TourID = parseInt(this.route.TourID)
            stops[stop].Direction = 1
            stops[stop].DeltaT = Math.floor(this.stops[stop].Duration / 60)
            stops[stop].Distance = this.stops[stop].Distance
            stops[stop].Lat = this.stops[stop].Lat
            stops[stop].Lng = this.stops[stop].Lng
            stops[stop].Stop = stop
            _stops[stop] = Object.assign({}, stops[stop])
            _stops[stop].Direction = 2
            for (let student in students) {
              let studentID = students[student].StudentID
              if (!students[student].deleted) {
                if (studentsStops[studentID] === undefined) studentsStops[studentID] = {}
                studentsStops[studentID].StudentID = studentID
                studentsStops[studentID].ToSchool = stops[stop].Stop
                studentsStops[studentID].ToHome = stops[stop].Stop
                studentsStops[studentID].TourID = students[student].TourID === undefined ? stops[stop].TourID : students[student].TourID
                studentsStops[studentID].BusID = this.route.BusID
              }
            }
          }
        }
        if (this.polyline === null) return [[], {}]
        return [[].concat.apply(stops, _stops), studentsStops]
      },
      save () {
        if (!this.route_ready(true)) return this.getDirection(this.partition())
        this.saveRoute()
      },
      saveRoute () {
        let data = this.reAssignStops()
        this.schedule.StartDate = this.$moment(this.schedule.StartDate).format('YYYY-MM-DD')
        this.schedule.EndDate = this.$moment(this.schedule.EndDate).format('YYYY-MM-DD')
        if (this.stops.length === 1) this.direction['Polyline'] = null
        let postData = {
          route: this.route,
          direction: this.direction,
          stops: data[0],
          students: data[1],
          schedule: this.schedule
        }
        let self = this
        this.saving = true
        this.$http.post('/route/save', postData).then(function (response) {
          self.saving = false
          let data = response.data
          self.message = data.message
          self.error = data.error
          if (!self.error) {
            self.$router.push({path: '/transportation/route'})
            self.$message({message: self.$t(self.message), type: 'success', showClose: true})
            return
          }
          self.$refs.OVForm.validate((valid) => {})
          self.$refs.routeForm.validate((valid) => {})
          self.$refs.infoForm.validate((valid) => {})
        }).catch(function () {
        })
      },
      sendRegistration () {
        let postData = {}
        let self = this
        if (this.selectedMonitor) {
          postData.supervisor = {FullName: this.monitor.FullName_EN.replace(' ', ''), email: this.monitor.EMail, BusMonitorID: this.monitor.BusMonitorID}
        }
        if (this.tickedDriver) {
          postData.driver = {FullName: this.driver.FullName_EN.replace(' ', ''), email: this.driver.EMail, BusDriverID: this.driver.BusDriverID}
        }
        if (this.selectedStudents.length !== 0) {
          postData.students = this.selectedStudents
        }
        this.sending = true
        this.$http.post('/registration', postData).then(function (response) {
          self.sending = false
          if (!response.data.error) {
            self.$message({message: response.data.message, type: 'success'})
            return
          }
        }).catch(function () {
        })
      },
      toRad (Value) {
        return Value * Math.PI / 180
      },
      clearEverything () {
        this.message = null
        this.selectedBus = null
        this.selectedDriver = null
        this.selectedSupervisor = null
        this.error = false
        this.item_checked = false
      },
      verifyItem () {
        let self = this
        let postData = 'BusDriverID=' + self.selectedDriver
        if (self.selectedSupervisor !== null) postData = 'BusMonitorID=' + self.selectedSupervisor
        if (self.selectedBus !== null) postData = 'BusID=' + self.selectedBus
        this.$http.get('/route/verify?' + postData + '&TourID=' + self.route.TourID).then(function (response) {
          self.message = response.data.message
          self.item_checked = response.data.error
        }).catch(function (response) {})
      },
      setBus () {
        this.route.BusID = this.selectedBus
        this.$refs.OVForm.validateField('BusID')
        this.showBuses = false
        for (let bus in this.buses) {
          if (this.buses[bus].BusID === this.selectedBus) {
            this.bus = this.buses[bus]
            break
          }
        }
        this.clearEverything()
      },
      setDriver () {
        this.route.BusDriverID = this.selectedDriver
        this.$refs.OVForm.validateField('BusDriverID')
        this.showDrivers = false
        for (let driver in this.drivers) {
          if (this.drivers[driver].BusDriverID === this.selectedDriver) {
            this.driver = this.drivers[driver]
            break
          }
        }
        this.clearEverything()
      },
      setSupervisor () {
        this.route.BusMonitorID = this.selectedSupervisor
        this.$refs.OVForm.validateField('BusMonitorID')
        this.showSupervisors = false
        for (let supervisor in this.supervisors) {
          if (this.supervisors[supervisor].BusMonitorID === this.selectedSupervisor) {
            this.monitor = this.supervisors[supervisor]
            break
          }
        }
        this.clearEverything()
      },
      getAcademicTerms () {
        let self = this
        this.$http.get('/configuration/academic_term')
        .then(function (response) {
          self.terms = response.data
        })
        .catch(function (res) {
        })
      },
      setTerm (TermID) {
        let term = null
        for (let item in this.terms) {
          if (this.terms[item].YearID === TermID) {
            term = this.terms[item]
            break
          }
        }
        this.direction.TermID = term.YearID
        this.schedule.StartDate = new Date(term.terms[0].StartDate)
        this.schedule.EndDate = new Date(term.terms[term.terms.length - 1].EndDate)
      },
      draftRoute () {
        // let self = this
        // if (this.direction.DraftAuthor !== null) return
        // this.$http.put('/route/draft', {TourID: this.route.TourID, TourName: this.route.TourName, DraftAuthor: this.DraftAuthor}).then(function (response) {
        //   if (response.data.TourID === undefined) return
        //   self.route.TourID = response.data.TourID
        //   self.direction.TourID = response.data.TourID
        //   self.schedule.TourID = response.data.TourID
        //   self.direction.DraftAuthor = response.data.DraftAuthor
        // }).catch(function (response) {})
      },
      getRoute () {
        let self = this
        if (this.$route.params.id === 'create') return
        this.loading = true
        this.$http.get('/route/' + this.$route.params.id + '').then(function (response) {
          self.route = response.data.route
          if (response.data.bus) self.bus = response.data.bus
          if (response.data.driver) self.driver = response.data.driver
          if (response.data.monitor) self.monitor = response.data.monitor
          if (response.data.direction) self.direction = response.data.direction
          self.direction.IsManual = parseInt(self.direction.IsManual)
          self.is_manual = !!self.direction.IsManual
          if (self.direction.TermID !== null) self.ServiceDate = 0
          self.routeSchedule(response.data.schedule)
          if (response.data.direction.Polyline !== null) self.drawPolyline([response.data.direction.Polyline[0]])
          self.getStops()
        }).catch(function (response) {})
      },
      getStops () {
        let self = this
        let params = {TourID: self.route.TourID, Updated: self.direction.Updated, DraftAuthor: self.direction.DraftAuthor, Snapshot: self.direction.Snapshot}
        this.$http.get('/route/stops', {params: params}).then(function (response) {
          self.loading = false
          if (response.data.stops === undefined) return
          self.direction.Snapshot = response.data.version
          self.drawMarkers(response.data.stops)
        }).catch(function (response) {})
      },
      drawMarkers (stops) {
        if (stops.length === 0) return
        this.stops = stops
        this.stops_order = []
        this.students = {}
        for (let stop in stops) {
          stop = parseInt(stop)
          if (stops[stop].students[0] === undefined) stops[stop].students = []
          let key = stops[stop].originLat + ',' + stops[stop].originLng
          this.coordinates[key] = stop
          if (this.markers[stop] !== undefined) this.markers[stop].setMap(null)
          let position = new this.maps.LatLng(stops[stop].Lat, stops[stop].Lng)
          this.markers[stop] = this.addMarker(position, stop, this.direction.RouteColor)
          this.markers[stop].setMap(this.map)
          if (stop > 0) {
            this.stops_order.push(stops[stop].stop_id)
            this.studentStop(stop)
          }
        }
        for (let i = this.stops.length; i < this.markers.length; i++) {
          if (this.markers[i] !== undefined) this.markers[i].setMap(null)
        }
      },
      studentStop (stop) {
        let students = this.stops[stop].students
        for (let student in students) {
          let StudentID = students[student].StudentID
          if (this.students[StudentID] === undefined) this.students[StudentID] = stop
        }
      },
      drawPolyline (directions) {
        if (directions.length === 0) return (this.is_ready = false)
        let path = []
        /* eslint new-cap: ["error", { "newIsCap": false }] */
        for (let polyline in directions) {
          path = path.concat(new this.maps.geometry.encoding.decodePath(directions[polyline]))
        }
        if (this.polyline !== null) this.polyline.setMap(null)
        this.polyline = new this.maps.Polyline({
          path: path,
          strokeColor: this.direction.RouteColor,
          strokeOpacity: 1.0,
          strokeWeight: 5
        })
        this.polyline.setMap(this.map)
        let paths = this.maps.geometry.encoding.encodePath(path)
        this.direction.Polyline = [paths, paths]
        this.is_ready = true
        this.routing = false
      },
      routeSchedule (schedule) {
        if (!schedule) return (this.schedule.TourID = this.route.TourID)
        this.schedule = schedule
        this.schedule.Direction = parseInt(this.schedule.Direction)
        this.schedule.StartDate = new Date(this.schedule.StartDate)
        this.schedule.EndDate = new Date(this.schedule.EndDate)
      },
      partition () {
        let p = 1
        let stops = []
        let deletedStops = []
        let coordinates = {}
        this.deleted_stops = 0
        this.deleted_students = {}
        let s = 0
        for (let stop in this.stops) {
          stop = parseInt(stop)
          if (!this.stops[stop].deleted) {
            let key = this.stops[stop].originLat + ',' + this.stops[stop].originLng
            this.stops[stop].stop_id = coordinates[key] = s++
            stops.push(this.stops[stop])
          } else {
            deletedStops.push(stop)
          }
        }
        for (let s in deletedStops) {
          this.removeStop(deletedStops[s])
        }
        this.coordinates = Object.assign({}, coordinates)
        this.stops = stops
        stops = this.clusterPoints()
        let points = stops.length
        if (points > 23 && points <= 46) p = 2
        if (points > 46) p = 3
        let results = []
        let chunks = Math.floor(points / p)
        let starting = 0
        let ending = 0
        if (p === 1) return [stops]
        for (let i = 0; i < p; i++) {
          ending += chunks + i
          results.push(stops.slice(starting, ending))
          starting += results[i].length
        }
        return results
      },
      getDirection (stops) {
        let directions = []
        let self = this
        self.routing = true
        for (let s in stops) {
          let points = stops[s]
          if (s > 0) points.unshift(stops[s - 1].slice(-1)[0])
          let k = points.length - 1
          let origin = new self.maps.LatLng({lat: points[0].Lat, lng: points[0].Lng})
          let destination = new self.maps.LatLng({lat: points[k].Lat, lng: points[k].Lng})
          points = points.slice(1, k)
          let wayPoints = []
          for (let point in points) {
            wayPoints.push({
              location: new self.maps.LatLng({lat: points[point].Lat, lng: points[point].Lng}),
              stopover: true
            })
          }
          directions.push(self.setDirection(origin, destination, wayPoints))
        }
        // let duration = 0
        // let distance = 0
        Promise.all(directions).then(function (routes) {
          let route = 0
          let directions = []
          let i = 1
          // let colors = ['#001f3f', '#FF4136', '#FF851B']
          let _stops = [self.stops[0]]
          for (route in routes) {
            route = parseInt(route)
            directions.push(routes[route].overview_polyline)
            let legs = routes[route].legs
            let orders = routes[route].waypoint_order
            orders.push(orders.length)
            let order = 0
            for (let leg in legs) {
              if (orders[leg] !== undefined) order = orders[leg] + 1
              let students = stops[route][order].students
              leg = parseInt(leg)
              let stop = {
                DeltaT: legs[leg].duration.value / 60,
                Distance: legs[leg].distance.value,
                Duration: legs[leg].duration.value,
                Lat: legs[leg].end_location.lat(),
                Lng: legs[leg].end_location.lng(),
                WaitingTime: students.length / 2,
                deleted: false,
                draft: false,
                inputs: false,
                mapDuration: 0,
                originLat: stops[route][order].Lat,
                originLng: stops[route][order].Lng,
                polyline: null,
                stop_id: i++,
                students: students
              }
              _stops.push(stop)
              // distance += legs[leg].distance.value
              // duration += legs[leg].duration.value
            }
          }
          self.stops = _stops
          self.is_ready = true
          self.routing = false
          self.drawMarkers(self.stops)
          self.drawPolyline(directions)
        })
      },
      setDirection (origin, destination, waypoints) {
        let self = this
        self.direction.IsManual = self.is_manual
        return new Promise(function (resolve, reject) {
          self.directionsService.route(
            {
              origin: origin,
              destination: destination,
              waypoints: waypoints,
              optimizeWaypoints: !self.direction.IsManual,
              travelMode: self.maps.DirectionsTravelMode.DRIVING
            },
          function (response, status) {
            if (status === 'OK') {
              let route = response.routes[0]
              resolve(route)
            } else {
              reject(status)
            }
          })
        })
      },
      initMap () {
        this.directionsService = new this.maps.DirectionsService()
        this.directionsDisplay = new this.maps.DirectionsRenderer({suppressMarkers: true})
        this.directionsDisplay.setMap(this.map)
      },
      pinSymbol (color) {
        return {
          path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
          fillColor: color,
          fillOpacity: 1,
          strokeColor: color,
          labelOrigin: new this.maps.Point(0, -25)
        }
      },
      addMarker (position, i, color) {
        if (i === 0) {
          return new this.maps.Marker({
            position: position,
            icon: require('../../assets/img/map/school.png')
          })
        }
        let label = i + ' '
        if (!color) color = '#f5c93c'
        return new this.maps.Marker({
          draggable: false,
          raiseOnDrag: true,
          position: position,
          icon: this.pinSymbol(color),
          animation: null,
          label: {
            text: label,
            color: '#fff',
            fontSize: '16px'
          },
          labelClass: 'marker-label'
        })
      },
      status () {
        let self = this
        let postData = {TourID: this.route.TourID, Deleted: this.route.Deleted}
        this.$http.post('/route/status', postData)
          .then(function (response) {
            self.$message(self.$t('ROUTESUCCESSFULLY') + ' ' + (self.route.Deleted === '1' ? self.$t('DEACTIVATED') : self.$t('RESTORED')))
            let EventBus = require('@/event-bus').EventBus
            EventBus.trips.total = response.data.trips
          })
          .catch(function (res) {
          })
      },
      cloneRoute () {
        let self = this
        this.cloning = true
        this.$http.get('/route/clone/' + this.route.TourID + '' + '&name=' + this.clonedName)
          .then(function (response) {
            self.cloning = false
            self.$message(self.$t('ROUTESUCCESSFULLYCLONED'))
          })
          .catch(function (res) {
          })
      },
      setPathColor (val) {
        if (this.polyline === null) return
        this.polyline.setOptions({strokeColor: val})
        for (let marker in this.markers) {
          if (parseInt(marker) !== 0) this.markers[marker].setIcon(this.pinSymbol(val))
        }
      },
      setDepature (val) {
        if (val === 3) return
        if (val === 1) {
          this.schedule.Time_PM_In = undefined
          this.schedule.Time_PM_Out = undefined
          this.departure = 1
        } else {
          this.schedule.Time_AM_In = undefined
          this.schedule.Time_AM_Out = undefined
          this.departure = 2
        }
      },
      changeDirection () {
      },
      pinStudentLocation (student) {
        let self = this
        if (self.pin_location !== null) self.pin_location.setMap(null)
        self.pin_location = new self.maps.Marker({
          map: self.map,
          animation: self.maps.Animation.BOUNCE,
          position: new this.maps.LatLng(student.Lat, student.Lng)
        })
        self.map.panTo(self.pin_location.getPosition())
      },
      clearSelections () {
        this.typed = this.typed === '' ? null : ''
        if (!this.showBuses) this.selectedBus = null
        if (!this.showDrivers) this.selectedDriver = null
        if (!this.showSupervisors) this.selectedSupervisor = null
      },
      uploadedFile (response, file, fileList) {
        let self = this
        if (response.error) {
          return self.$message({
            message: response.error,
            type: 'error',
            showClose: true
          })
        }
        self.$http.get('/student/coordinates', {params: {cvs_file: response.file_name}})
          .then(function (response) {
            self.bulkValidation(response.data.stops)
          }).catch(function (res) {})
      },
      bulkValidation (stops) {
        let self = this
        let s = this.stops.length
        let promises = []
        let studentStops = {}
        for (let stop in stops) {
          let students = stops[stop].students
          for (let student in students) {
            let StudentID = students[student].StudentID
            if (this.students[StudentID] === undefined) {
              studentStops[StudentID] = {stop: stop, student: students[student]}
              promises.push(this.checkRoute(StudentID))
            }
          }
        }
        Promise.all(promises).then(function (results) {
          for (let item in results) {
            let data = results[item].data
            if (data.success !== undefined) {
              let stop = studentStops[data.ID].stop
              let key = stops[stop].originLat + ',' + stops[stop].originLng
              let _stop = self.coordinates[key]
              if (_stop === undefined) {
                _stop = self.coordinates[key] = s++
                stops[stop].stop_id = _stop
                stops[stop].students = []
                self.stops.push(stops[stop])
              }
              self.stops[_stop].students.push(studentStops[data.ID].student)
            }
          }
          self.drawMarkers(self.stops)
          if (self.polyline !== null) self.polyline.setMap(null)
          self.progress_import = false
          self.is_ready = false
        })
      },
      processUpload () {
        this.progress_import = true
      },
      saveStops () {
        let stops = this.optimizeStops()
        if (!stops) return
        this.$http.post('/route/stops', {TourID: this.route.TourID, stops: stops})
          .then(function (response) {
          }).catch(function (res) {})
      },
      loadOptimizedRoute (data) {
        let self = this
        this.$http.get('/route/optimize', {params: data})
          .then(function (response) {
            self.$notify({
              title: 'Success',
              message: 'Route successfully optimized!',
              type: 'success'
            })
            self.drawMarkers(response.data.stops)
            self.drawPolyline(response.data.directions)
          }).catch(function (res) {})
      },
      arrangeStudentStop (students) {
        let studentIDs = []
        let draft = false
        let i = 0
        for (let student in students) {
          studentIDs.push(students[student].StudentID)
          i++
          if (students[student].deleted && !students[student].draft) {
            delete studentIDs.slice(i--, 1)
            draft = true
          } else if (!students[student].deleted && students[student].draft) {
            draft = true
          }
        }
        if (!draft) studentIDs = []
        return studentIDs
      },
      optimizeStops () {
        let stops = {}
        let deletedStops = []
        let type = 'school'
        let i = 0
        if (this.stops.length === 1) return false
        for (let item in this.stops) {
          item = parseInt(item)
          if (item > 0) type = 'stop'
          let stop = {
            Lat: this.stops[item].originLat,
            Lng: this.stops[item].originLng,
            Type: type,
            students: this.arrangeStudentStop(this.stops[item].students)
          }
          if ((this.stops[item].draft || stop.students.length > 0) && !this.stops[item].deleted) {
            let key = (this.direction.Snapshot !== null ? this.stops[item].stop_id : i++)
            stops[key] = stop
          } else if (this.stops[item].deleted && !this.stops[item].draft) {
            deletedStops.push(this.stops[item].stop_id + '')
          }
        }
        let data = {}
        if (deletedStops.length > 0) data.delete_waypoints = deletedStops
        if (Object.keys(stops).length > 0) data.modify = stops
        if (Object.keys(data).length === 0) return false
        return data
      },
      optimizeRoute () {
        let stops = this.optimizeStops()
        if (!stops) return
        if (this.is_ready) return this.$message(this.$t('ROUTEISOTIMIZED'))
        this.draftRoute()
        this.routing = true
        let event = this.API_KEY + '-' + this.route.TourID
        this.$channel.bind(event, (data) => {
          data.TourID = this.route.TourID
          this.direction.Snapshot = data.Version
          this.loadOptimizedRoute(data)
        }).bind(this)
        let self = this
        this.$http.put('/route/optimize', {TourID: this.route.TourID, stops: stops})
          .then(function (response) {
            if (response.data.stops === undefined) return
            self.drawMarkers(response.data.stops)
            self.drawPolyline(response.data.directions)
          }).catch(function (res) {})
      },
      removeStop (key) {
        this.$delete(this.stops, key)
        if (this.pin_location !== null) this.pin_location.setMap(null)
        this.markers[key].setMap(null)
        // this.is_ready = false
        if (this.deleted_stops === 0) this.is_ready = true
        this.students = {}
        for (let stop in this.stops) {
          this.studentStop(stop)
        }
      },
      validateStudents (students) {
        let deleteStudents = Object.keys(this.deleted_students).length
        let _delete = true
        if (students.length === deleteStudents) _delete = false
        for (let student in students) {
          let StudentID = students[student].StudentID
          if (this.deleted_students[StudentID] !== undefined) students[student].deleted = _delete
        }
        if (!_delete) this.deleted_students = {}
        return !_delete
      },
      deleteAction (item, key) {
        item.deleted = !item.deleted
        let isReady = true
        if (item.students !== undefined) {
          if (this.stops.length === 2) {
            item.draft = true
            if (this.polyline !== null) this.polyline.setMap(null)
            this.direction.Polyline = null
            this.stops_order = []
            this.polyline = null
          }
          if (item.draft && item.deleted) return this.removeStop(key)
          item.deleted ? this.deleted_stops++ : this.deleted_stops--
        } else {
          if (item.deleted && this.stops[key].draft && this.stops[key].students.length === 1) return this.removeStop(key)
          item.deleted ? this.$set(this.deleted_students, item.StudentID, key) : this.$delete(this.deleted_students, item.StudentID)
          if (this.validateStudents(this.stops[key].students)) return this.deleteAction(this.stops[key], key)
        }
        if (this.deleted_stops > 0 || this.drafted_stops > 0) isReady = false
        this.is_ready = isReady
      },
      scrollDown () {
        this.$nextTick(function () {
          this.$refs.ScrollbarStops.$el.scrollTop = this.$refs.stops.offsetHeight
          this.$refs.ScrollbarStops.update()
        })
      },
      cluster (stops, num) {
        let points = []
        for (let stop in stops) {
          let point = stops[stop]
          points.push([point.originLat, point.originLng])
        }
        if (points.length < 23) return [{points: points}]
        clusterMaker.data(points)
        return clusterMaker.clusters()
      },
      computeDistance (origin, destination) {
        let start = new this.maps.LatLng(origin.Lat, origin.Lng)
        let end = new this.maps.LatLng(destination.Lat, destination.Lng)
        return this.maps.geometry.spherical.computeDistanceBetween(start, end)
      },
      clusterPoints () {
        if (this.is_manual) return this.stops
        let stops = this.stops.slice()
        for (let stop in stops) {
          stops[stop].school_distance = this.computeDistance(stops[0], stops[stop])
        }
        let items = stops.sort(function (a, b) {
          return a.school_distance - b.school_distance
        })
        let clusters = this.sortClusters(items.slice(), 4)
        let _stops = [stops[0]]
        for (let cluster in clusters) {
          let points = clusters[cluster].points
          for (let point in points) {
            let key = points[point][0] + ',' + points[point][1]
            _stops.push(this.stops[this.coordinates[key]])
          }
        }
        return _stops
      },
      sortClusters (items, num) {
        if (num === undefined) num = 3
        let origin = items.shift()
        let clusters = this.cluster(items, num)
        let destination
        for (let cluster in clusters) {
          let point = clusters[cluster]
          if (point !== undefined) {
            destination = {Lat: point.points[0][0], Lng: point.points[0][1]}
            clusters[cluster].distance = this.computeDistance(origin, destination)
          }
        }
        return clusters.sort(function (a, b) {
          return a.distance - b.distance
        })
      },
      route_ready (matched) {
        if (matched && this.stops.length === 1) return (this.is_ready = true)
        let keys = Object.keys(this.stops)
        keys = keys.slice(1)
        let order1 = keys.join()
        let order2 = this.stops_order.join()
        let isReady = order1 === order2
        if (this.is_manual !== !!this.direction.IsManual && isReady === !this.is_manual) isReady = false
        if (this.direction.Polyline === null) isReady = false
        if (this.deleted_stops > 0) isReady = false
        if (matched) return (this.is_ready = isReady)
        this.is_manual = !this.is_manual
      }
    }
  }
</script>

<style>
.stop_btn{ display: block}
.stop_btn button{width:100%; display: block; border-radius: 0; padding:20px 0}
  .scroll{height: auto; overflow-y: auto; position: relative; margin: 0; padding: 0}
.scrollbar { width: 100%; background: none ;}
  .el-steps{padding-left:15px; padding-bottom: 15px; padding-top: 15px}
  #rtl   .el-steps {padding-right:15px;padding-left:0;}
  .el-step__title {margin-left: 0px; width:100% !important}
  .el-step__main{display:block !important; padding-left:40px !important; padding-right:15px !important; margin-top:-32px; padding-bottom:20px}
    #rtl   .el-step__main {padding-left:15px !important; padding-right:40px !important;  }
  .searchInput input{border-radius: 0 ;border-width: 0; border-top-width:1px}
  .only-bottom-border .el-input-group__prepend{border-radius: 0  !important; border-width: 0  !important; border-bottom-width:1px  !important}
  .only-bottom-border .el-select{width:120px  !important ;border-right:1px solid rgb(191, 203, 217); border-top:1px solid  rgb(191, 203, 217)}
  #rtl .only-bottom-border .el-select {border-right: 0;border-left:1px solid rgb(191, 203, 217); }
  .stop_btn{display: none}
  .el-step__main:hover .stop_btn{display: block}
  .el-step__main:hover .stop_btn{display: block}
  .timing .el-date-editor{width:170px !important}
  .marker-label{color:#fff !important; font-weight:bold}
  .scrollbar .el-step{margin-right: 0px; min-height: 200px}
  .scrollbar .el-step:first-child{min-height: 100px}
  .el-color-picker__empty{margin-top:-14px}
  .mapPin{float:right}
  #rtl .mapPin{float:left}
  .directionBtn{float:right}
  #rtl .directionBtn{float:left}
  .el-color-picker{float: left;}
  #OVForm .el-form-item__label {display: inline-flex;padding-top: 0px;width:70%}
  #OVForm .el-form-item__content {position: static;float:right;width:30%}
  #OVForm .el-form-item {position: relative;margin-bottom: 0px;width:100%}
  .el-step .stop-inputs,  #rtl .popover-btn{float:left}
  #rtl .el-step .stop-inputs, .popover-btn {float:right}
  .el-step .stop-inputs {text-align: right; margin: 0 }
  #rtl .el-step .stop-inputs {text-align: left; }
  #rtl #OVForm .el-form-item__label, #OVForm .el-form-item__error{padding:0px}
  .stopConfig .upload-demo{display: inline-block} 
 .stopConfig .el-button-group, .stopConfig .upload-csv, #rtl .el-color-picker {float:right}
  #rtl .stopConfig .el-button-group, #rtl .stopConfig .upload-csv, #rtl #OVForm .el-form-item__content {float:left}
  .header-search .el-input__inner {background-color: #4b4b4b; border: 0px;color: #fff;}
  .header-search input::-webkit-input-placeholder {font-family: "MavenProRegular", Arial, sans-serif;color: #fff;font-weight: bold;opacity: 1 !important;}
  #route-manage .el-dialog .el-table__body-wrapper{overflow-x: hidden;}
  .overflow-text{flex: 1 1 0%;min-width: 0px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-right: 1px}
  .dragged {background-color: rgb(221, 226, 226)}
  .el-card__header .drag-to-stop{display:inline-block !important; background: none; border:0; cursor:pointer; outline:none;}
.stop-steps .el-card__header .el-col:last-child, .stop-steps .move-stop{float:right !important;}
#rtl .stop-steps .el-card__header .el-col:last-child, #rtl .stop-steps .move-stop{float:left !important}


.btn-steps .el-button.manual-stops{    
  float:right;
    border-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;}


#rtl .btn-steps .el-button.manual-stops{  
    float:left;  
       border-radius: 0 !important;
    border-top-left-radius: 5px !important;
    border-bottom-left-radius:5px !important;}
.bounce-transition {
  display: inline-block; /* otherwise scale animation won't work */
}
.bounce-enter {
  animation: bounce-in .5s;
}
.bounce-leave {
  animation: bounce-out .5s;
}
.wrapper.el-button {
  display: inline-block;
  padding: 0;
  margin: 0;
  border: none;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(0);
  }
}
</style>




// WEBPACK FOOTER //
// RouteManage.vue?03b2f100